/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines, complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.

import React, { useState, useRef, useMemo } from 'react';
import { noop } from 'lodash-es';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { styled, truncate, withTheme } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { DSBackdrop } from '@elliemae/ds-backdrop';
import { Group } from '@elliemae/ds-shared';
import { DSMobileContextMenuGroup as ContextMenuGroup } from './MobileContextMenuGroup.js';

const StyledContainer = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['000']};
  z-index: ${(props) => props.zIndex};
  width: ${(props) => `calc(100% - ${props.theme.space.xs})`};
  position: fixed;
  bottom: 0;
  left: ${(props) => props.theme.space.xxs};
  max-height: 90vh;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow:
    0 0px 24px 0 rgba(0, 0, 0, 0.5),
    0 0px 11px 0 rgba(0, 0, 0, 0.5);
`;

const StyledTitle = styled(Grid)`
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  color: ${(props) => props.theme.colors.neutral['000']};
  ${truncate()}

  & > span {
    height: 20px;
    width: 20px;
  }

  & > span > svg,
  svg:not([fill]) {
    height: 20px;
    width: 20px;
    fill: ${(props) => props.theme.colors.neutral['000']};
  }
`;

const HeaderContainer = styled(Grid)`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: ${(props) => props.theme.colors.brand['600']};
`;

const isArr = (prop) => Array.isArray(prop);

const DSMobileContextMenu = withTheme(
  ({
    open = false,
    title = '',
    multiple = false,
    singleSelect = false,
    onChange = noop,
    onClickOutside = noop,
    children,
    theme,
    backdropZIndex = 1000,
    zIndex = 1001,
    dataTestid = 'mobile-context-menu',
    buttonFooter: ButtonFooter = null,
    onApply = noop,
    selecteds: initSelecteds,
    onKeyDown,
  }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const trueSelected = useMemo(
      () => (initSelecteds !== undefined ? initSelecteds : [...selectedItems]),
      [initSelecteds, selectedItems],
    );
    const containerRef = useRef(null);
    const handleChange = (value, childProps, event) => {
      onChange(value, childProps, event);
      if (initSelecteds === undefined) {
        if (multiple) setSelectedItems([...value]);
        else if (singleSelect) setSelectedItems(value);
      }
    };

    // this function is a mess, it is using "this" and invoking the onClick binded,
    //   it was somehow working based on handleApply.bind(ButtonFooter.props)
    //      which is arguably black magic
    // Converted to arrow function and converted "this" to ButtonFooter?.props
    const handleApply = (e) => {
      if (ButtonFooter?.props?.onClick) ButtonFooter?.props?.onClick?.(e);
      onApply(e, selectedItems);
    };

    const rows = [theme.space.s, 1];

    const footerProps = {
      containerProps: {
        'data-testid': `${dataTestid}--btn`,
      },
      buttonType: 'primary',
      size: 'l',
      // keeping the binding for legacy code just in case, I have no idea what the intent was here,
      //  composition based render-function will have no need for the binding, so only doing the binding for the React.cloneElement scenario
      onClick: (ButtonFooter?.props ?? false) === false ? handleApply : handleApply.bind(ButtonFooter.props),
    };
    if (ButtonFooter) rows.push('56px');

    if (!open) return null;

    return (
      <>
        <DSBackdrop
          type="cover"
          zIndex={backdropZIndex}
          onClick={(e) => {
            // PUI-4481 prevent click on elements below backdrop
            e.stopPropagation();
            onClickOutside(e);
          }}
        />
        <StyledContainer
          zIndex={zIndex}
          rows={rows}
          innerRef={containerRef}
          data-testid="ds-mobile-context-menu"
          onKeyDown={onKeyDown}
        >
          <HeaderContainer justifyContent="center" alignItems="center" pl="xs" pr="xs">
            <StyledTitle alignItems="center" gutter="xxs" cols={Array(isArr(title) ? title.length : 1).fill('auto')}>
              {title}
            </StyledTitle>
          </HeaderContainer>
          <Grid style={{ overflow: 'hidden' }}>
            <Grid style={{ overflow: 'auto' }}>
              <Group activeValue={trueSelected} multiple={multiple} onChange={handleChange}>
                {React.Children.map(children, (child, ii) => {
                  const isGroup =
                    child.type === (<ContextMenuGroup />).type ||
                    child.type?.name === ContextMenuGroup.componentType ||
                    child.type === ContextMenuGroup.type;
                  const { onClick = noop } = child.props;
                  const value = ii;
                  let isSelected;
                  if (singleSelect) isSelected = trueSelected === value;
                  else if (multiple) isSelected = trueSelected.includes(value);
                  return React.cloneElement(child, {
                    value,
                    // eslint-disable-next-line react/no-array-index-key
                    key: `cm.${ii}`,
                    isMulti: multiple,
                    singleSelect,
                    isSelected,
                    onClick: !isGroup ? (e) => onClick(e, child.props) : null,
                    selectedItems: isGroup ? trueSelected : null,
                  });
                })}
              </Group>
            </Grid>
          </Grid>
          {ButtonFooter ? (
            <Grid pl="xs" pr="xs" alignItems="center">
              {React.isValidElement(ButtonFooter) ? (
                React.cloneElement(ButtonFooter, footerProps)
              ) : (
                <ButtonFooter {...footerProps} />
              )}
            </Grid>
          ) : null}
        </StyledContainer>
      </>
    );
  },
);

const props = {
  /** toggle open the menu */
  open: PropTypes.bool.description('toggle open the menu'),
  /** context menu title  */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  ]).description('context menu title'),
  /** change handler for selectable context menu  */
  onChange: PropTypes.func.description('change handler for selectable context menu'),
  /** multi select */
  multiple: PropTypes.bool.description('multi select'),
  /** click outside callback handler */
  onClickOutside: PropTypes.func.description('click outside callback handler'),
  /** array of mobile context menu items */
  children: PropTypes.arrayOf(PropTypes.element).description('array of mobile context menu items'),
  /** z index for overlay div */
  backdropZIndex: PropTypes.number.description('z index for overlay div'),
  /** z index for menu container */
  zIndex: PropTypes.number.description('z index for menu container'),
  /** for e2e tests */
  dataTestid: PropTypes.string.description('for e2e tests'),
  /** bottom button */
  buttonFooter: PropTypes.element.description('bottom button'),
  /** callback */
  onApply: PropTypes.func.description('callback'),
  /** selected elements for multi and single select */
  selecteds: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    PropTypes.number,
  ]).description('selected elements for multi and single select'),
  onKeyDown: PropTypes.func.description('onKeyDown'),
};

DSMobileContextMenu.displayName = 'DSMobileContextMenu';
const DSMobileContextMenuWithSchema = describe(DSMobileContextMenu);

DSMobileContextMenuWithSchema.propTypes = props;

export { DSMobileContextMenu, DSMobileContextMenuWithSchema };
